import CustomLoading from "./CustomLoading";

export default CustomLoading;
